export default __webpack_public_path__ + "static/media/va-logo.932fe5f2.png";